<style>
  main {
    display: flex;
    flex-flow: row;
    height: 100%;
    width: 100%;
  }
  @media screen and (max-width: 800px) {
    main {
      flex-flow: column;
    }
  }
</style>

<script>
  import { onMount } from 'svelte';
  import auth from './auth';
  
  import Map from './comp/Map.svelte';
  import NavPanel from './comp/NavPanel.svelte';
  import SidePanel from './comp/SidePanel.svelte';
  
  onMount(async () => {
    await auth.init();
  });
</script>

<main>
  <NavPanel/>
  <SidePanel/>
  <Map/>
</main>
